import TrailDetailsCard from './TrailDetailsCard';

export default TrailDetailsCard;
